// extracted by mini-css-extract-plugin
module.exports = {"label":"styles__label___Oj0e8","required":"styles__required___3LAes","description":"styles__description___3f5B2","adminIcon":"styles__adminIcon___3Jjay"};